import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { from, Observable, of, merge, empty } from 'rxjs';
import { LoginService } from '../services/login.service';
import { UserService } from '../services/user.service';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChooseProjectComponent } from '../components/choose-project/choose-project.component';
import { BackdropComponent } from "../components/backdrop/backdrop.component";
import { TranslateService } from '@ngx-translate/core';
import { RegistrationService } from '../services/registration.service';

@Injectable({
  providedIn: 'root'
})
export class MainGuard implements CanActivate {

  constructor(
    private router: Router,
    private loginService: LoginService,
    private userService: UserService,
    private registerService: RegistrationService,
    private modalService: NgbModal,
    private translater: TranslateService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!!localStorage.getItem('token_info') || !!localStorage.getItem('user_id')) {

      let userId = JSON.parse(localStorage.getItem('user_id'));
      let token = JSON.parse(localStorage.getItem('token_info')).accessToken;
      let newUser = false;
      let isMember = true;
      let proj;

      let headline = "Choose Project";

      let backdropModalRef = this.modalService.open(BackdropComponent, { backdrop: 'static', windowClass: 'signInModal' });
      backdropModalRef.componentInstance.loadingText = "Loading...";

      if (!!localStorage.getItem('project_id')) {
        const projID = JSON.parse(localStorage.getItem('project_id'));
        return this.userService.loginToProject(projID.projectID.id).pipe(
          map(prlogin => {
            var pro_lang;
            const user_lng = localStorage.getItem('user_lng');
            try {
              pro_lang = prlogin.project.projectData.attributes.defaultLanguage[0];
            } catch (e) {
              pro_lang = 'NLD';
            }
            localStorage.setItem('project_lng', pro_lang);
            this.translater.use(user_lng || pro_lang)

            backdropModalRef.close();
            if (prlogin.role === 'DATA_COLLECTOR') {
              if (prlogin.user.attributes
                && prlogin.user.attributes.acceptedTermsOfUse
                && prlogin.user.attributes.acceptedTermsOfUse[0]
                && prlogin.user.attributes.acceptedPrivacyPolicy
                && prlogin.user.attributes.acceptedPrivacyPolicy[0]) {
                return true;
              } else {
                if (route.routeConfig.path === 'account/info') {
                  return true;
                }
                this.router.navigate(['account', 'info'], { state: { data: prlogin.user } });
                return false;
                // return true;
              }
            }
            return true;
          }),
          catchError((err, caught) => {
            localStorage.removeItem('project_id');
            this.router.navigate(['/login']);
            return empty();
          })
        );
      }
      else {
        if (userId) {
          return this.userService.getUserProjects(userId).pipe(
            mergeMap(result => {
              if (result.projectTreeMember.children.length > 0) {
                headline = "Login to your project";
                return of(result.projectTreeMember);
              }
              else {
                newUser = true;
                headline = "Select Project to register";

                if (result.projectTreeMember.properties) {
                  isMember = result.projectTreeMember.properties.isMember;
                }
                return this.registerService.getGemeente();
              }
            }),
            mergeMap(projects => {
              backdropModalRef.close();
              // check if single project
              if (!newUser) {
                if (projects.children.length === 1) {
                  const firstProject = projects.children[0];
                  if (firstProject.properties.isMember && !firstProject.children.length) {
                    localStorage.setItem('project_id', JSON.stringify(firstProject));
                    return from(of(firstProject));
                  }
                  if (!firstProject.properties.isMember && firstProject.children.length === 1) {
                    if (firstProject.children[0].properties.isMember) {
                      localStorage.setItem('project_id', JSON.stringify(firstProject.children[0]));
                      return from(of(firstProject.children[0]));
                    }
                  }
                }
              }
              let modalRef = this.modalService.open(ChooseProjectComponent, { backdrop: 'static' });
              modalRef.componentInstance.headline = headline;
              modalRef.componentInstance.isMember = isMember;
              if (newUser) modalRef.componentInstance.registered = true;
              else modalRef.componentInstance.registered = false;
              modalRef.componentInstance.tree = projects.children;
              return from(modalRef.result);
            }),
            mergeMap(project => {
              backdropModalRef = this.modalService.open(BackdropComponent, { backdrop: 'static', windowClass: 'signInModal' });
              backdropModalRef.componentInstance.loadingText = "Loading...";
              proj = project;
              const user_lng = localStorage.getItem('user_lng');
              let lang = user_lng || 'NLD'
              if (newUser) return this.registerService.registration(userId, lang, project.projectID.id);
              else return of(project);
            }),
            mergeMap(project => {
              return this.userService.loginToProject(proj.projectID.id);
            }),
            map(prlogin => {
              var pro_lang;
              const user_lng = localStorage.getItem('user_lng');
              try {
                pro_lang = prlogin.project.projectData.attributes.defaultLanguage[0];
              } catch (e) {
                pro_lang = 'NLD';
              }
              localStorage.setItem('project_lng', pro_lang);
              this.translater.use(user_lng || pro_lang)

              backdropModalRef.close();
              if (prlogin.role === 'DATA_COLLECTOR') {
                if (prlogin.user.attributes
                  && prlogin.user.attributes.acceptedTermsOfUse
                  && prlogin.user.attributes.acceptedTermsOfUse[0]
                  && prlogin.user.attributes.acceptedPrivacyPolicy
                  && prlogin.user.attributes.acceptedPrivacyPolicy[0]) {
                  return true;
                } else {
                  if (route.routeConfig.path === 'account/info') {
                    return true;
                  }
                  this.router.navigate(['account', 'info'], { state: { data: prlogin.user } });
                  return false;
                  // return true;
                }
              }
              return true;
            }),
            catchError((err, caught) => {
              const currentLang = localStorage.getItem('user_lng')
              localStorage.clear();
              localStorage.setItem('user_lng',currentLang)
              this.router.navigate(['/login']);
              return empty();
            })
          );
        }
        else {
          return this.loginService.getMyInfo(token).pipe(
            mergeMap(result => {
              localStorage.setItem('user_id', JSON.stringify(result.userId.id));
              return this.userService.getUserProjects(result.userId.id);
            }),
            mergeMap(result => {
              if (result.projectTreeMember.children.length > 0) {
                headline = "Login to your project";
                return of(result.projectTreeMember);
              }
              else {
                newUser = true;
                headline = "Select Project to register";

                if (result.projectTreeMember.properties) {
                  isMember = result.projectTreeMember.properties.isMember;
                }
                return this.registerService.getGemeente();
              }
            }),
            mergeMap(projects => {
              backdropModalRef.close();
              // check if single project
              if (!newUser) {
                if (projects.children.length === 1) {
                  const firstProject = projects.children[0];
                  if (firstProject.properties.isMember && !firstProject.children.length) {
                    localStorage.setItem('project_id', JSON.stringify(firstProject));
                    return from(of(firstProject));
                  }
                  if (!firstProject.properties.isMember && firstProject.children.length === 1) {
                    if (firstProject.children[0].properties.isMember) {
                      localStorage.setItem('project_id', JSON.stringify(firstProject.children[0]));
                      return from(of(firstProject.children[0]));
                    }
                  }
                }
              }
              let modalRef = this.modalService.open(ChooseProjectComponent, { backdrop: 'static' });
              modalRef.componentInstance.headline = headline;
              modalRef.componentInstance.isMember = isMember;
              if (newUser) modalRef.componentInstance.registered = true;
              else modalRef.componentInstance.registered = false;
              modalRef.componentInstance.tree = projects.children;
              return from(modalRef.result);
            }),
            mergeMap(project => {
              backdropModalRef = this.modalService.open(BackdropComponent, { backdrop: 'static', windowClass: 'signInModal' });
              backdropModalRef.componentInstance.loadingText = "Loading...";
              proj = project;
              const user = JSON.parse(localStorage.getItem('user_id'));
               const user_lng = localStorage.getItem('user_lng');
              let lang = user_lng || 'NLD'
              if (newUser) return this.registerService.registration(user, lang, project.projectID.id);
              else return of(project);
            }),
            mergeMap(project => {
              return this.userService.loginToProject(proj.projectID.id);
            }),
            map(prlogin => {
              var pro_lang;
              const user_lng = localStorage.getItem('user_lng');
              try {
                pro_lang = prlogin.project.projectData.attributes.defaultLanguage[0];
              } catch (e) {
                pro_lang = 'NLD';
              }
              localStorage.setItem('project_lng', pro_lang);
              this.translater.use(user_lng || pro_lang)

              backdropModalRef.close();
              if (prlogin.role === 'DATA_COLLECTOR') {
                if (prlogin.user.attributes
                  && prlogin.user.attributes.acceptedTermsOfUse
                  && prlogin.user.attributes.acceptedTermsOfUse[0]
                  && prlogin.user.attributes.acceptedPrivacyPolicy
                  && prlogin.user.attributes.acceptedPrivacyPolicy[0]) {
                  return true;
                } else {
                  if (route.routeConfig.path === 'account/info') {
                    return true;
                  }
                  this.router.navigate(['account', 'info'], { state: { data: prlogin.user } });
                  return false;
                  // return true;
                }
              }
              return true;
            }),
            catchError((err, caught) => {
              const currentLang = localStorage.getItem('user_lng')
              localStorage.clear();
              localStorage.setItem('user_lng',currentLang)
              this.router.navigate(['/login']);
              return empty();
            })
          );
        }

      }
      // return true;//this.loginService.checkToken().pipe(map(token => !!token!.active));
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
